import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-social-index',
  templateUrl: './social-index.component.html',
  styleUrls: ['./social-index.component.scss']
})
export class SocialIndexComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
